import { http } from './Connect';
import type { AxiosResponse } from 'axios';
import { buildUrl } from '@/helpers/buildUrl';

export async function getProviders(): Promise<string[]> {
  return http
    .get(buildUrl(`/api/v1/app/control/{operatorId}/streamer/game/provider`))
    .then(({ data }: AxiosResponse<string[]>) => data);
}
